<div class="example-container">
  <div
    [@routeAnimations]="
      o && o.activatedRouteData && o.activatedRouteData['animation']
    "
  >
    <router-outlet #o="outlet"></router-outlet>
  </div>
</div>
<!-- <a id="back-to-top" title="Back to top" style="display: none"
  ><i class="fas fa-arrow-up"></i
></a> -->
